import { create } from 'zustand';

interface SessionEvent {
    type: 'title_updated' | 'deleted' | 'created';
    sessionId: string;
    title?: string;
    timestamp: number;
}

interface SessionStore {
    // State
    currentSessionId: string | null;
    isWelcomeState: boolean;
    isCreatingSession: boolean;
    isStreaming: boolean;
    lastSessionEvent: SessionEvent | null;

    // Actions
    setCurrentSession: (sessionId: string | null) => void;
    setWelcomeState: (isWelcome: boolean) => void;
    setCreatingSession: (isCreating: boolean) => void;
    setStreaming: (isStreaming: boolean) => void;
    notifySessionEvent: (event: Omit<SessionEvent, 'timestamp'>) => void;
}

export const useSessionStore = create<SessionStore>((set) => ({
    // Initial state
    currentSessionId: null,
    isWelcomeState: true,
    isCreatingSession: false,
    isStreaming: true,
    lastSessionEvent: null,

    // Actions
    setCurrentSession: (sessionId) => set({ currentSessionId: sessionId }),

    setWelcomeState: (isWelcome) => set({ isWelcomeState: isWelcome }),

    setCreatingSession: (isCreating) => set({ isCreatingSession: isCreating }),

    setStreaming: (isStreaming) => set({ isStreaming: isStreaming }),

    notifySessionEvent: (event) =>
        set({ lastSessionEvent: { ...event, timestamp: Date.now() } }),
}));
